import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import "./sass/googleReviewSection.scss";

// Static review data
const staticReviews = [
  {
    id: 1,
    name: "Kimberly Noyce",
    rating: 5,
    text: "Highly recommend !!!! Ali did a great job with all of the projects I gave him. Lots of patience and very fast. Very knowledgeable with marketing, websites, social media platforms etc. Responded quickly to all of my questions and was very patient when I changed my mind on different things.",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 2,
    name: "Benoit",
    rating: 5,
    text: "Thank you for your services for our business. Really satisfied with your service and reports.",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 3,
    name: "A-D Rehman",
    rating: 5,
    text: "I joined Softorithm for AI Creation and Graphic Designing classes, and it’s been an amazing experience. The instructors are skilled, supportive, and make learning easy and practical. The courses are well-structured, blending real-world …More",
    timeAgo: "3 months ago",
    avatar:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 4,
    name: "huzaifah butt",
    rating: 5,
    text: "SoftoRithm Technologies is an outstanding digital marketing agency. Their team is professional, and they know exactly what they are doing. They have provided me the best web development services. They are not only experts in web development …More",
    timeAgo: "2 months ago",
    avatar:
      "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 5,
    name: "AD",
    rating: 5,
    text: "The team of SoftoRithm Technologies is very cooperative and experienced. They have achieved all goals and given the perfect e-commerce website for my jewelry business. Highly recommend their affordable services in the region of Jalalpur Jattan.",
    timeAgo: "4 months ago",
    avatar:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 6,
    name: "Azeem Ashraf",
    rating: 5,
    text: "A great name in the SEO business. I've had the pleasure of working with them. Excellent services and exceptional customer service. Highly recommended for business of all sizes from all industries!",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 7,
    name: "Muhammad Mubashir",
    rating: 5,
    text: "Best experience of SEO services. Really appreciated!",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 8,
    name: "wahab ijaz",
    rating: 5,
    text: "Best SEO services provider.",
    timeAgo: "6 years ago",
    avatar: "",
  },
  {
    id: 9,
    name: "Talha Ahmad",
    rating: 5,
    text: "Great. Highly Recommended. Keep it up!",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 10,
    name: "saqib ali",
    rating: 5,
    text: "Great service. Satisfied.",
    timeAgo: "6 years ago",
    avatar: "",
  },
  {
    id: 11,
    name: "anonymous account",
    rating: 5,
    text: "Good and efficient service .. .Best quality",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 12,
    name: "Sadda Hussain",
    rating: 5,
    text: "Excellent SEO Services",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1545996124-0501ebae84d0?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 13,
    name: "Waqar Khalid",
    rating: 5,
    text: "Excellent service",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 14,
    name: "ch waqas",
    rating: 5,
    text: "Good servises👍👍👍",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 15,
    name: "Al Jehdami International",
    rating: 5,
    text: "Satisfied services",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 16,
    name: "azaad panchii",
    rating: 5,
    text: "Good service",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 17,
    name: "pitbull planet",
    rating: 5,
    text: "Excelent services",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=50&h=50&fit=crop&crop=face",
  },
];

const GoogleReviewSection = ({
  isBest = true,
  title = "Smart, Straight-Talking UK Web Design",
  subtitle = "Professional websites built to attract customers, boost your search rankings, and grow your business. Trusted by companies in Leeds and across the UK for over 12 years.",
  buttonText = "See Our Work",
  onButtonClick = () => {},
  customReviews = null,
  companyName = "Softorithm",
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [visibleReviews, setVisibleReviews] = useState(4);
  const [showLoadMore, setShowLoadMore] = useState(true);

  const reviews = customReviews || staticReviews;

  const handleLoadMore = () => {
    const newCount = visibleReviews + 4;
    setVisibleReviews(newCount);
    if (newCount >= reviews.length) {
      setShowLoadMore(false);
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Reset visible reviews when sidebar opens
  useEffect(() => {
    if (sidebarOpen) {
      setVisibleReviews(4);
      setShowLoadMore(true);
    }
  }, [sidebarOpen]);

  // Prevent body scroll when sidebar is open
  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [sidebarOpen]);

  return (
    <>
      {/* Section 1 - Hero with Google Review */}
      <section className="hero-section">
        <div className="container">
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="hero-content text-white">
                <h1 className="display-4 fw-bold mb-4">
                  <>
                   {isBest && "Best," }
                    <br />
                    {title}
                    <br />
                    {/* <span>Web Design</span> */}
                  </>
                </h1>
                <button
                  className="btn btn-info btn-lg px-4 py-3"
                  // onClick={onButtonClick}
                  onClick={toggleSidebar}
                >
                  {buttonText}
                </button>
              </div>
            </Col>
            <Col lg={6}>
              <div className="hero-description text-white">
                {/* <p className="lead mb-4">{subtitle}</p> */}
                <div className="google-review-widget text-white text-center">
                  <div className="google-logo mb-3" onClick={toggleSidebar}>
                    <i
                      className="ri-google-fill google-icon"
                      style={{ fontSize: "45px" }}
                    ></i>
                  </div>

                  {/* Google Reviews Text */}
                  <div className="google-reviews-text mb-3">
                    <h4 className="mb-2">Google Reviews</h4>
                    <p className="mb-0">Trusted by 200+ customers</p>
                  </div>

                  <div className="rating-display mb-3">
                    <span className="rating-number">5.0</span>
                    <div className="stars">
                      {[...Array(5)].map((_, i) => (
                        <span key={i}>★</span>
                      ))}
                    </div>
                  </div>
                  <div className="review-link mb-3">
                    <span onClick={toggleSidebar}>Read reviews</span>
                  </div>
                  <div className="reviewer-avatars">
                    {reviews.slice(0, 6).map((review, index) => (
                      <img
                        key={review.id}
                        src={review.avatar}
                        alt={review.name}
                        style={{
                          marginLeft: index > 0 ? "-10px" : "0",
                          zIndex: 6 - index,
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Review Sidebar */}
      {sidebarOpen && (
        <div className="review-sidebar-overlay" onClick={closeSidebar}>
          <div className="review-sidebar" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <div className="d-flex justify-content-end mb-4">
              <button className="close-btn" onClick={closeSidebar}>
                ×
              </button>
            </div>

            {/* AI Summary Section */}
            <div className="ai-summary">
              <div className="d-flex align-items-center mb-3">
                <div className="ai-badge">
                  <span>AI</span>
                </div>
                <span style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                  AI-Generated Summary
                </span>
              </div>
              <p style={{ color: "#9CA3AF", fontSize: "0.9rem" }}>
                Based on 200 Google reviews
              </p>

              <div className="summary-points">
                <div className="d-flex align-items-start">
                  <span>✓</span>
                  <span>
                    {companyName} is highly professional and attentive,
                    delivering quality results.
                  </span>
                </div>
                <div className="d-flex align-items-start">
                  <span>✓</span>
                  <span>
                    Clients praise the company for its creativity, attention to
                    detail, and ability to bring their vision to life.
                  </span>
                </div>
                <div className="d-flex align-items-start">
                  <span>✓</span>
                  <span>
                    {companyName} is recommended for anyone in need of digital
                    marketing, web design, or SEO services.
                  </span>
                </div>
              </div>
            </div>

            {/* Individual Reviews */}
            <div className="individual-reviews">
              {reviews.slice(0, visibleReviews).map((review) => (
                <div key={review.id} className="review-item">
                  <div className="reviewer-info d-flex align-items-center mb-2">
                    {review?.avatar ? (
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="reviewer-avatar"
                      />
                    ) : (
                      <div className="avatar-fallback reviewer-avatar">
                        {review?.name?.charAt(0)}
                      </div>
                    )}

                    <div className="reviewer-details ms-2">
                      <div className="reviewer-name">{review.name}</div>
                      <div className="review-time">{review.timeAgo}</div>
                    </div>
                  </div>

                  <div className="stars">
                    {[...Array(review.rating)].map((_, i) => (
                      <span key={i}>★</span>
                    ))}
                  </div>

                  <div className="review-text">{review.text}</div>

                  <div className="review-source d-flex align-items-center">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                        fill="#4285F4"
                      />
                      <path
                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                        fill="#34A853"
                      />
                      <path
                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                        fill="#FBBC05"
                      />
                      <path
                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                        fill="#EA4335"
                      />
                    </svg>
                    <span>Posted on </span>
                    <span className="google-text">Google</span>
                  </div>
                </div>
              ))}

              {/* Load More Button */}
              {showLoadMore && (
                <div className="text-center mt-4">
                  <button onClick={handleLoadMore} className="load-more-btn">
                    Load 4 More Reviews
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GoogleReviewSection;
